
<form class="p-3" #playerForm="ngForm" (ngSubmit)="playerForm.valid && updatePlayerGameID()" novalidate>
    <div class="mb-3">
        <label for="game_id" class="form-label">Game <em>*</em></label>
    </div>
    <div class="mb-3">
        <label for="username" class="form-label">Player Game Username <em>*</em></label>
        <input type="text" maxlength="20" minlength="3" class="form-control" id="username" name="username" #username="ngModel" [(ngModel)]="player_id_data.username" required>
        <div *ngIf="playerForm.submitted && username.invalid" class="invalid-feedback">
            <div *ngIf="username.errors.required">Player Game ID is required.</div>
            <div *ngIf="username.errors.minlength">Player Game ID minimun length is 3.</div>
            <div *ngIf="username.errors.maxlength">Player Game ID maximum length is 20.</div>
        </div>
    </div>
    <div class="mb-3">
        <label for="status" class="form-label">Status <em>*</em></label>
        <select class="form-control" name="status" #status="ngModel" [(ngModel)]="player_id_data.status" required>
            <option [value]="1">Active</option>
            <option [value]="0">Disabled</option>
            <option [value]="99">Delete</option>
        </select>
        <div *ngIf="playerForm.submitted && status.invalid" class="invalid-feedback">
            <div *ngIf="status.errors.required">Status is required</div>
        </div>
    </div>
    <div class="d-flex flex-row">
        <button type="submit" class="btn btn-primary">
            <span *ngIf="!player_id_data.id">Add</span>
            <span *ngIf="player_id_data.id">Update</span> Player Game ID
        </button>
        
    </div>
</form>